import {
	DateRangePicker as BaseDateRangePicker,
	type DateRangePickerProps,
	type RangeValue,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { useFieldContext, useLanguage } from "@onesolution/hooks";

export function DateRangePicker(props: DateRangePickerProps) {
	const field = useFieldContext<RangeValue<never> | null>();
	const { t } = useLanguage();

	return (
		<BaseDateRangePicker
			labelPlacement="outside"
			isInvalid={!field.state.meta.isValid}
			startContent={
				field.state.value?.start ? (
					<Icon
						className="cursor-pointer min-w-4 text-foreground"
						icon="solar:close-circle-line-duotone"
						width={24}
						height={24}
						onClick={() => field.handleChange(null)}
					/>
				) : null
			}
			aria-label="daterange"
			id={field.name}
			errorMessage={t("message.required")}
			value={field.state.value}
			onBlur={field.handleBlur}
			onChange={(dateRange) => dateRange && field.handleChange(dateRange)}
			{...props}
		/>
	);
}
